/**
 * LCW Animated Text
 * Adiciona .is-visible quando o elemento entra no viewport.
 * O estado inicial (opacity:0, translateY) vive no CSS via [data-animate].
 */
if (!customElements.get('lcw-animated-text')) {
class LcwAnimatedText extends HTMLElement {
  /* Cada letra é uma caixinha separada (para subir sozinha), e isso faz a
     fonte perder o encaixe entre pares de letras ("PA", "AC"...): o título
     ficava ~3% mais largo que o mesmo texto normal. Aqui o encaixe de cada
     par é medido no canvas e devolvido como margem — o desenho volta a
     ficar idêntico ao do texto sem animação. */
  ajustarEncaixe() {
    const primeira = this.querySelector('.lcw-char');
    if (!primeira) return;
    const cs = getComputedStyle(primeira);
    const ctx = (LcwAnimatedText.canvas ||= document.createElement('canvas')).getContext('2d');
    ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    if ('fontKerning' in ctx) ctx.fontKerning = 'normal';
    const maiusc = cs.textTransform === 'uppercase';
    const larg = (t) => ctx.measureText(maiusc ? t.toUpperCase() : t).width;
    this.querySelectorAll('.lcw-word').forEach((palavra) => {
      const letras = [...palavra.querySelectorAll('.lcw-char')];
      letras.forEach((el, i) => {
        el.style.marginRight = '';
        const prox = letras[i + 1];
        if (!prox) return;
        const a = el.textContent;
        const b = prox.textContent;
        const encaixe = larg(a + b) - larg(a) - larg(b);
        if (Math.abs(encaixe) > 0.05) el.style.marginRight = `${encaixe.toFixed(2)}px`;
      });
    });
  }

  connectedCallback() {
    const ajustar = () => this.ajustarEncaixe();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
    else ajustar();
    if (!LcwAnimatedText.ouvindo) {
      LcwAnimatedText.ouvindo = true;
      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => document.querySelectorAll('lcw-animated-text').forEach((el) => el.ajustarEncaixe && el.ajustarEncaixe()), 200);
      });
    }

    if (window.Shopify && window.Shopify.designMode) {
      this.classList.add('is-visible');
      return;
    }

    if (!this.hasAttribute('data-animate')) {
      this.classList.add('is-visible');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => this.classList.add('is-visible'));
            obs.disconnect();
            break;
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(this);
  }
}

customElements.define('lcw-animated-text', LcwAnimatedText);
}
